import { IHttpApi } from '@cian/http-api';
import {
  fetchApiCallbackAdd,
  IApiCallbackAddRequest,
  IApiCallbackAddResponse,
} from '../../repositories/monolith-python/unversioned/api-callback-add';

export async function sendCallback(
  httpApi: IHttpApi,
  parameters: IApiCallbackAddRequest,
): Promise<IApiCallbackAddResponse> {
  const { response } = await fetchApiCallbackAdd({
    httpApi,
    parameters,
    config: {
      requestConfig: {
        withCredentials: false,
      },
    },
  });

  return response;
}
